import { render, staticRenderFns } from "./Artikel.vue?vue&type=template&id=dfd872e0&scoped=true&"
import script from "./Artikel.vue?vue&type=script&lang=js&"
export * from "./Artikel.vue?vue&type=script&lang=js&"
import style0 from "./Artikel.vue?vue&type=style&index=0&id=dfd872e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd872e0",
  null
  
)

export default component.exports